import Footer from "@/components/Footer";
import logoac from "@/imagenes/lg_act_economicas.png";
import useTable from "@/components/useTableServerSide";
import { useState, useRef, useEffect } from "react";
import { SearchInput } from "@/ui/inputs/Input";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "@/components/mensajes2";
import { Dimmer } from "@/components/spinner";
import { ActualizarEstadoCuenta } from "./modalActualizarEstadoCuenta";
import comercioService from "./service/comercio.service";
import moment from "moment";
import { utils, writeFile } from "xlsx";
import { formatoFecha } from "@/util/varios";
export default function DasboardActividad() {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const fecha = new Date();
  const efiscalanio = JSON.parse(localStorage.getItem("efiscalanio"));
  const espiritu = localStorage.getItem("espiritu");
  const fechaSistema = localStorage.getItem("fechasistema");
  const factorCambio = JSON.parse(localStorage.getItem("factorCambio"));

  const searchTimeoutRef = useRef(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [mostrarEstadoCuenta, setMostrarEstadoCuenta] = useState(false);
  const [llamado, setLlamado] = useState(0);
  const [parametro, setParametro] = useState(0);
  const [comercio, setComercio] = useState();
  const [persona, setPersona] = useState();
  const [actividad, setActividad] = useState();
  const [inmuebleCome, setInmuebleCome] = useState();
  const [deuda, setDeuda] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [multas, setMultas] = useState([]);
  const [retencion, setRetencion] = useState([]);
  const [facturasPagadas, setFacturasPagadas] = useState();
  const [facturasPagadasEtax, setFacturasPagadasEtax] = useState();
  const [facturasOtrosPgosEtax, setFacturasOtrosPgosEtax] = useState();
  const [statusCome, setStatusCome] = useState();
  const [licenciaMantenimiento, setLicenciaMantenimiento] = useState("");
  const [licenciaLicores, setLicenciaLicores] = useState("");
  const [licenciaComercio, setLicenciaComercio] =
    useState("");
  const [totales, setTotales] = useState({
    totalComercios: 0,
    comerciosActivos: 0,
    comerciosInactivos: 0,
    comerciosDeclarados: 0,
    comerciosSinDeclarar: 0,
    licencias: 0,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });

  const headCells = [
    {
      id: "1",
      label: "CODIGO",
      disableSorting: false,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "2",
      label: "RITM",
      disableSorting: false,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "3",
      label: "RIF",
      disableSorting: false,
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "4",
      label: "Razón Social",
      disableSorting: false,
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "5",
      label: "Dirección",
      disableSorting: false,
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const cardsData = [
    {
      title: "COMERCIOS REGISTRADOS",
      value: totales.totalComercios || 0,
      color: "#053160",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => procesarImprimir(1, 1),
    },
    {
      title: "COMERCIOS ACTIVOS",
      value: totales.comerciosActivos || 0,
      color: "#76b8e8",
      icon: "fas fa-toggle-on fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => procesarImprimir(2, 1),
    },

    {
      title: "COMERCIOS INACTIVOS",
      value: totales.comerciosInactivos || 0,
      color: "#ca4117",
      icon: "fas fa-toggle-off fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => procesarImprimir(3, 1),
    },
    {
      title: "COMERCIOS DECLARANDO",
      value: totales.comerciosDeclarados || 0,
      color: "#4e80b1",
      icon: "fas fa-file-alt fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => procesarImprimir(4, 1),
    },
    {
      title: "COMERCIOS SIN DECLARAR",
      value: totales.comerciosSinDeclarar || 0,
      color: "#8FCFC9",
      icon: "fas fa-file-alt fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => procesarImprimir(5, 1),
    },
    {
      title: "LICENCIAS EMITIDAS",
      value: totales.licencias || 0,
      color: "#e6640e",
      icon: "fas fa-id-badge fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => procesarImprimir(0, 2),
    },
  ];

  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
  };

  const { TblContainer, TblHead, TblPagination } = useTable(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };

  const buscarRegistrosComercios = () => {
    setLoading(true);
    const campos = "idcomercio, nombre, rif, ritm, direccion, status";
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      campos: campos,
      nomtab: "comercio",
      orden: "idcomercio desc",
      anio: efiscalanio,
      fecha: `${fecha.toLocaleDateString()}`,
    };
    const endpoint = `${op.conexion}/api/comun/actividad-economica/dashboard`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          setTotales({
            totalComercios: response.data.totales.total,
            comerciosActivos: response.data.totales.activos,
            comerciosInactivos: response.data.totales.inactivos,
            comerciosDeclarados: response.data.totales.comercios_declarados,
            comerciosSinDeclarar: response.data.totales.comercios_no_declarados,
            licencias: response.data.totales.licencias_emitidas,
          });
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  const buscarComercio = async (idComercio) => {
    setLoading(true);
    try {
      const resComercio = await axios.get(
        `${op.conexion}/api/industria/comerciopersona?idcomercio=${idComercio}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      const dataCom = resComercio.data;
      setComercio(dataCom);

      const idactividad = dataCom?.idactividad || 0;
      const idinmueble = dataCom?.idinmueble || 0;
      const esagente = dataCom?.esagentereten || false;

      setPersona({
        cedula: dataCom.cedula,
        nombres: dataCom.nombres,
        apellidos: dataCom.apellidos,
        correoe: dataCom.correoe,
        tlf1: dataCom.tlf1,
        tlf2: dataCom.tlf2,
        fnacimiento: dataCom.fnacimiento,
        nacionalidad: dataCom.nacionalidad,
        sexo: dataCom.sexo,
        direccion: dataCom.direccionp,
      });

      // 2. ACTIVIDAD
      const resActividad = await axios.get(
        `${op.conexion}/api/industria/actividad?idactividad=${idactividad}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (resActividad.data.length > 0) setActividad(resActividad.data);

      // 3. INMUEBLE
      const resInmueble = await axios.get(
        `${op.conexion}/api/industria/inmueblexcomercio?idinmueble=${idinmueble}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (resInmueble.data) setInmuebleCome(resInmueble.data);

      // 4. DEUDA (Separa pendientes de históricos)
      const endpointDeuda =
        espiritu === "0"
          ? `${op.conexion}/api/industria/deudacomerciors?idcomercio=${idComercio}&fecha=${fechaSistema}&espiritu=${espiritu}&tipounid=1`
          : `${op.conexion}/api/industria/deudacomercio?idcomercio=${idComercio}&fecha=${fechaSistema}&espiritu=${espiritu}&tipounid=1`;

      const resDeuda = await axios.get(endpointDeuda, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });

      let deu = [];
      let his = [];
      if (resDeuda.data && resDeuda.data.length > 0) {
        for (let i = 0; i < resDeuda.data.length; i++) {
          const d = resDeuda.data[i];
          if (d.fechapago === null) {
            deu.push({
              anio: d.anio,
              mes: d.mes ? d.mes.replace(/'/g, "") : "",
              monto: d.mondeu,
              intereses: d.intmoradeu,
              recargo: d.recargodeu,
              multa: d.multa,
              retenciones: d.retencion,
              credito: d.acreditacion,
              totalperi: d.subtotal,
              status: d.estatus,
              idfac: d.idfact,
              nummes: d.nmes,
              estatusfac: d.estatusfac,
              tipotransaccion: d.tipotransaccion,
            });
          } else {
            his.push({
              anio: d.anio,
              mes: d.mes ? d.mes.replace(/'/g, "") : "",
              monto: d.mondeu,
              intereses: d.intmoradeu,
              recargo: d.recargodeu,
              multa: d.multa,
              descuento: d.mondescue,
              recibo: d.numreci,
              fechapago: d.fechapago,
              status: d.estatus,
              idfac: d.idfact,
              estatusfac: d.estatusfac,
              tipotransaccion: d.tipotransaccion,
            });
          }
        }
      }
      setDeuda(deu);
      setHistorico(his);

      // 5. MULTAS
      const campMultas =
        "idmulta, fechamulta, CONCAT(descripcion, ' (', tipoimpuesto, ')') AS descripcion, concepto, monto, cancelada";
      const endpointMultas = `${op.conexion}/api/comun/seleccionaregistros?campos=
      ${campMultas}&nomtab=multa 
      where idcontribuyente = ${idComercio} and (tipoimpuesto = 'RENTAS DE LICORES' or  tipoimpuesto = 'ACTIVIDADES ECONOMICAS')
      &orden=idmulta desc`;

      const resMultas = await axios.get(endpointMultas, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      setMultas(resMultas.data);
      const camposLicenciasMantenimiento = `nrocertif, fechaemision, fechvence`;
      const nomtabLicenciaMantenimiento = `mant_licenciaxcomercio 
      where idcomercio = ${idComercio}`;
      const ordenLicenciaMantenimiento = `fechaemision desc 
      limit 1`;
      const endpointLicenciaMantenimiento =
        op.conexion +
        `/api/comun/seleccionaregistros?campos=${camposLicenciasMantenimiento}&nomtab=${nomtabLicenciaMantenimiento}&orden=${ordenLicenciaMantenimiento}`;
      const resLicenciaMantenimiento = await axios.get(
        endpointLicenciaMantenimiento,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (
        resLicenciaMantenimiento.status === 200 &&
        resLicenciaMantenimiento.data &&
        resLicenciaMantenimiento.data.length > 0
      ) {
        setLicenciaMantenimiento(resLicenciaMantenimiento.data[0]);
      } else {
        setLicenciaMantenimiento("");
      }
      // licencia de licores
      const camposLicenciaLicores = `numlicencia, fechaemision, fechvence`;
      const nomtabLicenciaLicores = `licenciaxlicoreria
      where idcomercio = ${idComercio}`;
      const ordenLicenciaLicores = `fechaemision desc
      limit 1
      `;
      const endpointLicenciaLicores =
        op.conexion +
        `/api/comun/seleccionaregistros?campos=${camposLicenciaLicores}&nomtab=${nomtabLicenciaLicores}&orden=${ordenLicenciaLicores}`;
      const resLicenciaLicores = await axios.get(endpointLicenciaLicores, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (
        resLicenciaLicores.status === 200 &&
        resLicenciaLicores.data &&
        resLicenciaLicores.data.length > 0
      ) {
        setLicenciaLicores(resLicenciaLicores.data[0]);
      } else {
        setLicenciaLicores("");
      }
      // licencia de comercio
      const camposLicenciaComercio = `nrolicencia, fechaemision, fechvence`;
      const nomtabLicenciaComercio = `Licenciaxcomercio
      where idcomercio = ${idComercio}`;
      const ordenLicenciaComercio = `fechaemision desc
      limit 1
      `;
      const endpointLicenciaComercio =
        op.conexion +
        `/api/comun/seleccionaregistros?campos=${camposLicenciaComercio}&nomtab=${nomtabLicenciaComercio}&orden=${ordenLicenciaComercio}`;
      const resLicenciaComercio = await axios.get(endpointLicenciaComercio, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (
        resLicenciaComercio.status === 200 &&
        resLicenciaComercio.data &&
        resLicenciaComercio.data.length > 0
      ) {
        setLicenciaComercio(resLicenciaComercio.data[0]);
      } else {
        setLicenciaComercio("");
      }
      
      
      // 6. FACTURAS PAGADAS Y RETENCIONES (Solo si es agente de retención)
      if (esagente) {
        const resFacturas = await axios.get(
          `${op.conexion}/api/industria/facturaspagadas?idcomercio=${idComercio}`,
          {
            headers: {
              "x-access-token": `${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        setFacturasPagadas(resFacturas.data);

        const resRetenciones = await axios.get(
          `${op.conexion}/api/industria/retencionesxagente?idcomercio=${idComercio}`,
          {},
          {
            // Nota: Pasé {} como body porque en tu código original estaba undefined y daba error
            headers: {
              "x-access-token": `${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        setRetencion(resRetenciones.data);
      } else {
        setFacturasPagadas([]);
        setRetencion([]);
      }
      //Status
      const data = await comercioService.getStatus();
      var come = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].tipostatus.trim() === "COMERCIO") {
          come.push({
            idstatus: data[i].idstatus,
            descripcion: data[i].descripcion,
          });
        }
        setStatusCome(come);
      }
      // Si todo salió bien, abrimos el modal
      setMostrarEstadoCuenta(true);
    } catch (error) {
      console.error("Error en el flujo de peticiones:", error);
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response?.data?.message ||
          "Error al cargar la información del comercio",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const procesarImprimir = (ope, llamado) => {
    setParametro(ope);
    setLlamado(llamado);
    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: "Desea Imprimir En Formato Excel?",
      icono: "confirmacion",
    });
  };
  const imprimirComerciosRegistrados = async (ope) => {
    let reporte = "ListGenComercioActividad";
    let condicion = "";
    let status_cade = "";
    let sql3 = "";
    let sql2 = "";
    let sql4 = "";
    let sql5 = "idcomercio";

    if (parametro === 4) {
      reporte = "ListaComercioDeclarados";
      condicion = `d.fechadeclaracion between '${efiscalanio}-01-01' and '${moment.utc(fecha).format("YYYY-MM-DD")}'`;
    }

    if (parametro === 1) {
      sql3 = "";
      sql2 = "LISTADO DE COMERCIOS REGISTRADOS";
      condicion = "  true";
    } else if (parametro === 2) {
      status_cade = "51";
      sql3 = "";
      sql2 = "";
      sql4 = "CONTRIBUYENTES ACTIVOS";
      condicion = "  COM.STATUS = 51";
    } else if (parametro === 3) {
      status_cade = "52";
      sql3 = "";
      sql2 = "";
      sql4 = "CONTRIBUYENTES INACTIVOS";
      condicion = "  COM.STATUS != 51";
    } else if (parametro === 5) {
      reporte = "ListaComerciosSinDeclarar";
      // Corregido YYYY-MM-DD en lugar de YYYY-MM-MM
      condicion = `c.status = 51 and dj.fechadeclaracion not between '${efiscalanio}-01-01' and '${moment.utc(fecha).format("YYYY-MM-DD")}'`;
    }
    // --- NUEVO BLOQUE PARA EXCEL CUANDO ES PARÁMETRO 5 ---
    if (ope === 1 && parametro === 5) {
      try {
        setLoading(true);
        const campos = `
          c.idcomercio,
          c.rif,
          c.ritm,
          c.nombre,
          c.direccion,
          ult_dj.ultima_fecha AS fechadeclaracion,
          COALESCE(ult_dj.mes || ' / ' || ult_dj.anio, 'Sin Declaración') AS periodo
        `;

        // Incluimos el LEFT JOIN y el WHERE NOT EXISTS directamente en el nomtab
        // Reemplazamos el $P!{CONDICION} por la variable condicion de JS
        const nomtab = `
          comercio c 
          LEFT JOIN (
              SELECT DISTINCT ON (idcomercio) 
                  idcomercio, 
                  fechadeclaracion AS ultima_fecha,
                  mes, 
                  anio
              FROM djurada d
              ORDER BY idcomercio, fechadeclaracion DESC
          ) ult_dj ON ult_dj.idcomercio = c.idcomercio
          WHERE NOT EXISTS (
              SELECT 1 
              FROM djurada d
              WHERE d.idcomercio = c.idcomercio 
                AND ${condicion}
          )
        `;

        const orden = "c.idcomercio DESC";

        const endpoint =
          op.conexion +
          `/api/comun/seleccionaregistros?campos=${encodeURIComponent(campos)}&nomtab=${encodeURIComponent(nomtab)}&orden=${encodeURIComponent(orden)}`;

        await axios.get(endpoint).then((response) => {
          const { data } = response;
          const worksheet = utils.json_to_sheet(data);
          const workbook = utils.book_new();
          utils.book_append_sheet(workbook, worksheet, "SinDeclarar"); // Nombre de la pestaña
          writeFile(
            workbook,
            `ComerciosSinDeclarar-${formatoFecha(new Date(), "dd/mm/yyyy")}.xlsx`, // Nombre del archivo
          );
        });
      } catch (error) {
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: "Error al Generar el excel de comercios sin declarar",
          icono: "error",
        });
      } finally {
        setLoading(false);
      }
      return; // Importante para que corte el flujo y no siga al window.open de abajo
    }
    // --- FIN DEL NUEVO BLOQUE ---
    else if (ope === 1 && parametro === 4) {
      try {
        setLoading(true);
        const campos = `
        DISTINCT ON (c.idcomercio)
    c.idcomercio,
    c.rif,
    c.ritm,
    c.nombre,
    c.direccion,
    TO_CHAR(d.fechadeclaracion, 'DD-MM-YYYY') as fechadeclaracion,
      d.mes || ' / ' || d.anio as periodo`;
        const nomtab = `comercio c 
  INNER JOIN djurada d ON d.idcomercio = c.idcomercio 
  where d.fechadeclaracion between '01-01-${efiscalanio}' and '${moment.utc(fecha).format("YYYY-MM-DD")}' and c.status = 51`;
        const orden = "c.idcomercio, d.fechadeclaracion DESC";
        const endpoint =
          op.conexion +
          `/api/comun/seleccionaregistros?campos=${encodeURIComponent(campos)}&nomtab=${encodeURIComponent(nomtab)}&orden=${encodeURIComponent(orden)}`;
        await axios.get(endpoint).then((response) => {
          const { data } = response;
          const worksheet = utils.json_to_sheet(data);
          const workbook = utils.book_new();
          utils.book_append_sheet(workbook, worksheet, "Users");
          writeFile(
            workbook,
            `ListGenComercioActividad-${formatoFecha(new Date(), "dd/mm/yyyy")}.xlsx`,
          );
        });
      } catch (error) {
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: "Error al Generar el excel",
          icono: "error",
        });
      } finally {
        setLoading(false);
      }
      return;
    }

    if (ope === 1) {
      try {
        setLoading(true);
        const campos = `SectorCatastral AS sSECTOR	,COM.IdComercio 	AS CODIGO
      ,CodigoCatastral 	AS sCODCAT	,Rif 		AS sCODTRI
      ,Ritm 			as sCODUNI	,Cuenta 		AS sCONTRI
      ,Nombre					,direccion
      ,AXC.IdActividad 	AS nREGACT
      ,AXC.CodigoActividad  	AS nCODACT
      ,ACT.CodigoCiu  	AS nCODCIU
      ,ACT.Descripcion    AS sDESACT
      ,NumeroLicencia	 	AS nLICENC
      ,CodigoPatente	 	AS nPATENT
      ,FechaInscripcion 	AS dFCHINS	,FechaDeclaracion   AS dFCHDEC
      ,Status			,ObservacionStatus  AS sOBSERV
      ,( SELECT Descripcion FROM STATUS WHERE Status=IdStatus )  AS sDESCRI
      , tipocontribuyente`;
        const nomtab = `Comercio AS COM 
      LEFT JOIN actividadxcomercio AS AXC ON AXC.IdComercio=COM.IdComercio  
      LEFT JOIN Actividad AS ACT ON AXC.IdActividad=ACT.IdActividad
    WHERE ${condicion}`;
        const orden = "COM.Idcomercio, AXC.IdActividad";
        const endpoint =
          op.conexion +
          `/api/comun/seleccionaregistros?campos=${encodeURIComponent(campos)}&nomtab=${encodeURIComponent(nomtab)}&orden=${encodeURIComponent(orden)}`;
        await axios.get(endpoint).then((response) => {
          const { data } = response;
          const worksheet = utils.json_to_sheet(data);
          const workbook = utils.book_new();
          utils.book_append_sheet(workbook, worksheet, "Users");
          writeFile(
            workbook,
            `ListGenComercioActividad-${formatoFecha(new Date(), "dd/mm/yyyy")}.xlsx`,
          );
        });
      } catch (error) {
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: "Error al Generar el excel",
          icono: "error",
        });
      } finally {
        setLoading(false);
      }
    } else {
      window.open(
        op.reportes +
          "/actividadeconomica?reporte=" +
          reporte +
          "&CONDICION=" +
          condicion +
          "&TIT_RGO1=" +
          sql2 +
          "&ORDEN=" +
          sql5 +
          "&TIT_ADICIONAL=" +
          sql4,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
  };

  const imprimirLicenciasEmitidas = async (ope) => {
    let reporte = "ListGenLicenciaComercio";
    if (parametro === 4) {
      reporte = "ListaComercioDeclarados";
    }
    let condicion = "";
    let sql3 = "";
    let sql2 = "COMERCIOS REGISTRADOS";
    let sql4 = "";
    let sql5 = "idcomercio";
    condicion = " anio = " + efiscalanio;

    if (ope === 1) {
      try {
        setLoading(true);
        const campos = `lxc.fechaemision, lxc.anio,com.IdComercio  AS CODIGO
	,Rif 		AS sCODTRI
	,Ritm 			as sCODUNI	,Nombre	,direccion
	,COM.IdActividad 	AS nREGACT
	,ACT.CodigoActividad  	AS nCODACT	,ACT.Descripcion    AS sDESACT
	,NumeroLicencia		 AS nLICENC
	,CodigoPatente	 	AS nPATENT
	,FechaInscripcion	 AS dFCHINS	,FechaDeclaracion   AS dFCHDEC
	,Status		,ObservacionStatus  AS sOBSERV
	,( SELECT Descripcion FROM STATUS WHERE Status=IdStatus )  AS sDESCRI
	, tipocontribuyente`;
        const nomtab = `licenciaxcomercio AS lxc 
	LEFT JOIN Comercio AS COM ON COM.Idcomercio =  lxc.Idcomercio 
	LEFT JOIN Actividad AS ACT ON COM.IdActividad=ACT.IdActividad
  where ${condicion}
  `;
        const orden = `fechaemision`;
        const endpoint =
          op.conexion +
          `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        await axios.get(endpoint).then((response) => {
          const { data } = response;
          const worksheet = utils.json_to_sheet(data);
          const workbook = utils.book_new();
          utils.book_append_sheet(workbook, worksheet, "Users");
          writeFile(
            workbook,
            `ListGenLicenciaComercio-${formatoFecha(new Date(), "dd/mm/yyyy")}.xlsx`,
          );
        });
      } catch (error) {
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: "Error al Generar el excel",
          icono: "error",
        });
      } finally {
        setLoading(false);
      }
    } else {
      window.open(
        op.reportes +
          "/actividadeconomica?reporte=" +
          reporte +
          "&CONDICION=" +
          condicion +
          "&TIT_RGO1=" +
          sql2 +
          "&ORDEN=" +
          sql5 +
          "&TIT_ADICIONAL=" +
          sql4,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
  };
  const cerrarModal = () => {
    setMostrarEstadoCuenta(false);
    setComercio();
    setPersona();
    setActividad();
    setInmuebleCome();
    setDeuda([]);
    setHistorico([]);
    setMultas([]);
    setRetencion([]);
    setFacturasPagadas();
    setFacturasPagadasEtax();
    setFacturasOtrosPgosEtax();
  };

  useEffect(() => {
    const cleanup = buscarRegistrosComercios();
    return () => {
      if (cleanup) cleanup();
    };
  }, [tableState]);

  return (
    <div
      className="container-fluid p-4"
      style={{ backgroundColor: "#f8f9fa", height: "90vh" }}
    >
      <div className="row g-4 mb-4">
        {cardsData.map((card, index) => (
          <div
            key={index}
            style={{ borderRadius: 4 }}
            className="col-12 col-sm-6 col-xl"
          >
            <div
              className="card h-100 border-0 rounded-4 shadow-sm position-relative overflow-hidden"
              style={{
                background: card.color,
                color: "white",
                transition: "transform 0.3s, box-shadow 0.3s",
                borderRadius: 15,
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
              }}
            >
              {/* Círculo decorativo */}
              <div
                style={{
                  position: "absolute",
                  top: -20,
                  right: -20,
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: -30,
                  left: -30,
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.05)",
                }}
              ></div>

              <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <span
                      className="text-uppercase small fw-bold opacity-75"
                      style={{ letterSpacing: "2px", fontSize: "1rem" }}
                    >
                      {card.title}
                    </span>
                    <h2
                      className="fw-bold mb-0 mt-1"
                      style={{ fontSize: "2.2rem" }}
                    >
                      {card.value}
                    </h2>
                  </div>
                  <i
                    className={card.icon}
                    style={{ color: card.iconColor }}
                  ></i>
                </div>
                {card.print && (
                  <div
                    className="mt-2"
                    style={{ position: "relative", zIndex: 10 }}
                  >
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        card.print();
                      }}
                      className="btn btn-sm btn-light rounded-circle p-2"
                      style={{
                        width: "35px",
                        height: "35px",
                        cursor: "pointer",
                        position: "relative",
                        zIndex: 20,
                      }}
                    >
                      <i className="fas fa-print"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="row g-4">
        <div className="col-8">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "15px" }}
          >
            <div className="card-header azulGradiant text-white">
              <h5 className="mb-0 fw-bold">
                <i className="fas fa-search me-2"></i>Consultar Deudas y Multas
              </h5>
            </div>
            <div className="card-body p-0 m-0">
              <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between align-items-start">
                <div className="col-4 m-0 p-0 position-relative">
                  <SearchInput
                    className="search-input pe-4"
                    value={searchInput}
                    onChange={handleSearch}
                  />
                </div>
              </div>
              <section className="col-12 m-0 p-0">
                <TblContainer>
                  <TblHead />
                  <tbody>
                    {records &&
                      records.map((item, index) => (
                        <tr
                          key={index}
                          style={{ padding: "0", cursor: "pointer" }}
                          onClick={() => buscarComercio(item.idcomercio)}
                        >
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "10px",
                            }}
                          >
                            {item.idcomercio}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "10px",
                            }}
                          >
                            {item.ritm}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {item.rif}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "left",
                              width: "auto",
                            }}
                          >
                            {item.nombre}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "left",
                              width: "auto",
                            }}
                          >
                            {item.direccion}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </section>
            </div>
          </div>
        </div>

        <div className="col-4">
          <div
            className="card shadow-1-strong h-100 border-0 d-flex align-items-center justify-content-center"
            style={{ borderRadius: "15px", minHeight: "400px" }}
          >
            <div className="text-center p-4">
              <img
                src={logoac}
                alt="Dashboard Illustration"
                className="img-fluid"
                style={{
                  maxHeight: "250px",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <ActualizarEstadoCuenta
        show={mostrarEstadoCuenta}
        onHideCancela={cerrarModal}
        actividad={actividad}
        comercio={comercio}
        statuscome={statusCome}
        actividadcome={actividad}
        representante={persona}
        tabdeuda={deuda}
        tabpago={historico}
        tabmulta={multas}
        tabreten={retencion}
        inmueble={inmuebleCome}
        espiritu={espiritu}
        factpago={facturasPagadas}
        factorCambio={factorCambio?.valor}
        factpagoetax={facturasPagadasEtax}
        factotropagoetax={facturasOtrosPgosEtax}
        deshabilitado={true}
        licenciaMantenimiento={licenciaMantenimiento}
        licenciaLicores={licenciaLicores}
        licenciaComercio={licenciaComercio}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() => {
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
          if (llamado === 1) imprimirComerciosRegistrados(2);
          else if (llamado === 2) imprimirLicenciasEmitidas(2);
        }}
        onHideSi={() => {
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
          if (llamado === 1) imprimirComerciosRegistrados(1);
          else if (llamado === 2) imprimirLicenciasEmitidas(1);
        }}
      />

      <Dimmer active={loading} inverted />
      <Footer />
    </div>
  );
}
